import { Button, Flex, SegmentedControl, Tabs, Text } from "@mantine/core"
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { FilterProps } from "types/module/User";

const Filter = ({ filters, setFilters }: FilterProps) => {
  return (
    <Flex justify="space-between">
      <Tabs
        value={String(filters.isInviting)}
        onChange={(value) =>
          setFilters({ ...filters, isInviting: value === "true" })
        }
        variant="outline"
        mt={2}
        mb={-1}
        pl={10}
        styles={{
          tab: {
            zIndex: "9",
          },
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="false">
            <Text size="md">Users</Text>
          </Tabs.Tab>
          <Tabs.Tab value="true">
            <Text size="md">Invitation Status</Text>
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Flex gap="sm" mt={0}>
        {!filters.isInviting && (
          <SegmentedControl
            style={{ alignSelf: "flex-start" }}
            data={[
              {
                label: "All",
                value: "",
              },
              {
                label: "Active",
                value: "active",
              },
              {
                label: "Inactive",
                value: "inactive",
              },
            ]}
            onChange={(value) =>
              setFilters((prev) => ({
                ...prev,
                status: value,
              }))
            }
            value={filters.status}
          />
        )}
        {Cookies.get("user_permission")
          .split("-")
          .includes("userOnboarding") && (
            <Link to="/user/onboarding">
              <Button>Add User</Button>
            </Link>
          )}
      </Flex>
    </Flex>
  )
}

export default Filter
